import React from 'react';
import { Container, Typography } from '@material-ui/core';
export const SDKAccessDenied = () => {
    return (
        <Container>
            <Typography variant="h1">404 - Access Denied</Typography>
            <Typography variant="p">
                You don't have access to this page
            </Typography>
        </Container>
    );
};
